import { useTranslation } from 'react-i18next';
import { InformationDark } from '@mafc/icon';
import { COLORS } from '@mafc/common';

import useDrawerControls from 'hooks/useDrawerControls';
import HowOurFeesWork from '../HowOurFeesWork';

import * as S from './ReadAboutOurFee.style';

const ReadAboutOurFee = () => {
  const { t } = useTranslation();

  const { isOpen, closeDrawer, openDrawer } = useDrawerControls();

  return (
    <>
      <S.ReadAboutButton onClick={openDrawer} variant="link">
        <S.ReadAboutText>{t('orderSummary.readAboutFee')}</S.ReadAboutText>
        <InformationDark fill={COLORS.ANCHOR_BLUE} />
      </S.ReadAboutButton>

      <HowOurFeesWork isOpen={isOpen} closeDrawer={closeDrawer} />
    </>
  );
};

export default ReadAboutOurFee;
